import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout'
import ConfigSettings from './ConfigSettings'
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

async function action({ store, intl }) {
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().adminPrevileges.privileges && store.getState().adminPrevileges.privileges.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }
    // Admin restriction
    if (!restrictUrls('/siteadmin/settings/site', adminPrivileges)) {
        return { redirect: '/siteadmin' };
    }

    const title = intl.formatMessage(messages.configSettings);
    return {
        title,
        component: (
            <AdminLayout>
                <ConfigSettings />
            </AdminLayout>
        )
    }
}

export default action